import React, { useState, useEffect } from 'react';
import ApiService from '../../functions/apiService';
import { Paper, Grid, Typography, TextField, Autocomplete, Avatar, MenuItem, Box } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import InputAdornment from "@mui/material/InputAdornment";
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Multiselect from 'multiselect-react-dropdown';
import './checklist.css'
import AddChecklistHierarchy from './AddChecklistHierarchy';

const AddChecklist = () => {
  const [employees, setEmployees] = useState([])
  const [employeesNew, setEmployeesNew] = useState([])

  const [loading, setLoading] = useState(false);
  const [checklistDesc, setChecklistDesc] = useState('');
  const [checklistItem, setChecklistItem] = useState('');
  const [detailsArr, setDetailsArr] = useState([]);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [locationDrop, setLocationDrop] = useState([]);
  const [duration, setDuration] = useState("");
  const [date, setDate] = useState(new Date());
  const [day, setDay] = useState("")
  const [assignedTo, setAssignedTo] = useState(null);
  const [position, setPosition] = useState(null);
  const [positionDrop, setPositionDrop] = useState([]);
  const [time, setTime] = useState(null);
  const [item, setItem] = useState("");
  const [itemDrop, setItemDrop] = useState([]);
  const [ticketAssignTo, setTicketAssignTo] = useState("");
  const [ticketNotifyTo, setTicketNotifyTo] = useState([]);
  const [nestedData, setNestedData] = useState([]);
  let navigate = useNavigate();
  const [targets, setTargets] = useState([])
  const [checklistUpdateTo, setChecklistUpdateTo] = useState("");

  const loadEmployees = () => {
    setLoading(true);
    ApiService.get('/employee-list-inventory')
      .then(({ data }) => {
        var tempArr = []
        data.data.map((emp) => {
          // var obj = emp
          var obj = {
            label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
            value: emp.Emp_Code
          }
          // obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
          // obj.value = emp.Emp_Code
          tempArr.push(obj)
        })
        setEmployees(tempArr)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      })

      ApiService.get('/employee-list-inventory-new')
      .then(({ data }) => {
        var tempArr = []
        data.data.map((emp) => {
          // var obj = emp
          var obj = {
            label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
            value: emp.Emp_Code
          }
          tempArr.push(obj)
        })
        setEmployeesNew(tempArr)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const getPositionDropown = () => {
    setLoading(true);
    ApiService.get('/positions-list')
      .then(({ data }) => {
        var certArr = data?.data.map((cer) => { return { label: cer.SO_Desc, value: cer.SO_Value } })
        setPositionDrop(certArr)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const getLocation = () => {
    setLoading(true);
    ApiService.get('/checklist/location')
      .then(({ data }) => {
        var posArr = data?.data.map((pos) => { return { label: pos.location_description, value: pos.id } })
        setLocationDrop(posArr)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const getItem = () => {
    const body = {
      "location_id": location
    }
    setLoading(true);
    ApiService.post('/checklist/hirearchy_data', body)
      .then((data) => {
        var load = data?.data.my_items.map((ldd) => { return { label: ldd.item_description, value: ldd.id } })
        setItemDrop(load)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  // const addElement = () => {
  //     if (checklistItem == '') {
  //         toast.error('Please add item')
  //     }
  //     else {
  //         let tempArr = [...detailsArr]
  //         let obj = {
  //             id : checklistItem.value,
  //             location_parent_id : checklistItem.location_parent_id,
  //             location_status : checklistItem.location_status ,
  //             type : checklistItem.type,
  //             desc: checklistDesc,
  //             label: checklistItem.label
  //         }
  //         tempArr.push(obj)
  //         setDetailsArr(tempArr)
  //         setChecklistDesc('')
  //         setChecklistItem('')
  //     }
  // }

  const deleteElement = (a) => {
    let tempArr = [...detailsArr]
    const index = tempArr.indexOf(a)
    tempArr.splice(index, 1)
    setDetailsArr(tempArr)
  }

  const editElement = (a) => {
    setChecklistDesc(a.desc)
    setChecklistItem({ label: a.label, value: a.item })
    deleteElement(a)
  }

  const addChecklist = () => {
    var addedDetails = [...detailsArr]
    if (checklistItem != '') {
      let obj = {
        desc: checklistDesc,
        item: checklistItem.value,
        label: checklistItem.label
      }
      addedDetails.push(obj)
    }
    var tempDetails = addedDetails.map((arr) => { return { description: arr.desc.length > 0 ? arr.desc : null, item_id: arr.item } })
    var tempDay = (duration == 'monthly' || duration == 'everyotherday') ? moment(date).format('YYYY-MM-DD') : day
    const body = {
      "title": title,
      "parent_location_id": location,
      "duration": duration,
      "day": tempDay,
      "assignedTo": assignedTo?.value,
      "position": position?.value,
      "time": moment(time).format('HH:mm:ss'),
      "ticket_assigned_to": ticketAssignTo?.value,
      "notify_employees": ticketNotifyTo.map((a)=>{return a?.value}),
			"notify_checklist_update_to": checklistUpdateTo?.value,
      "targets": targets,
    }
    setLoading(true);
    ApiService.post('/checklist/add', body)
      .then((data) => {
        setLoading(false);
        toast.success(data.message)
        navigate("/firehouse/checklist");
      })
			.catch((error) => {
				setLoading(false);
				if (error.status === 422) {
					const errorMessages = Object.keys(error?.data?.errors || {})
						.map((err) => error.data.errors[err][0])
						.filter(Boolean);

					if (errorMessages.length) {
						toast.error(
							<div>
								{errorMessages.map((msg, index) => (
									<div key={index}>• {msg}</div>
								))}
							</div>
						);
					}
				} else {
					toast.error(error?.data?.message);
				}
			})
		}

  const durationOptions = [
    { label: "Daily", value: "daily" },
    { label: "Every Other Day", value: "everyotherday" },
    { label: "Weekly", value: "weekly" },
    { label: "Bi-weekly", value: "biweekly" },
    { label: "Monthly", value: "monthly" }
  ]

  const dayOptions = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" }
  ]

  useEffect(() => {
    loadEmployees()
    getPositionDropown()
    getLocation()
  }, [])

  useEffect(() => {
    getItem()
  }, [location])


  const markAllSelected = (node) => {
    node.selected = true;

    if (node.locations && node.locations.length > 0) {
      node.locations = node.locations.map(markAllSelected);
    }

    if (node.items && node.items.length > 0) {
      node.items = node.items.map(item => ({ ...item, selected: true }));
    }

    return node;
  };

  let loadData = () => {
    const body = {
      "id": location,
    }
    ApiService.post('/checklist/hirearchy_data', body)
      .then((data) => {
        const updatedData = markAllSelected(data?.data);
        setNestedData(updatedData);
      }).catch((e) => {
        console.error("error")
      })
  }

  useEffect(() => {
    loadData();
  }, [location, setLocation]);

  // const buildTargets = (node) => {
  //   if (!node.selected) return null;

  //   const result = {
  //     description: node.desc || '',
  //     location_id: node.id || node.location_id,
  //     type: node.type || (node.item ? 'item' : 'location'),
  //     parent_location_id: node.location_parent_id
  //   };

  //   const subLocations = node.locations?.map(buildTargets).filter(Boolean);
  //   const items = node.items?.filter(i => i.selected).map(item => ({
  //     description: item.desc || '',
  //     item_id: item.item_id,
  //     parent_location_id: item.location_id,
  //     type: 'item'
  //   }));

  //   if (subLocations?.length) result["sub-location"] = subLocations;
  //   if (items?.length) result["items"] = items;

  //   return result;
  // };

	const buildSubTree = (node) => {
		if (!node.selected) return null;

		const result = {
			description: node.desc || '',
			location_id: node.id,
			parent_location_id: node.location_parent_id,
			type: node.type || (node.item ? 'item' : 'location'),
		};

		const items = node.items?.filter(i => i.selected).map(item => ({
			description: item.desc || '',
			item_id: item.item_id,
			parent_location_id: item.location_id,
			type: 'item'
		}));

		const subLocations = node.locations?.map(buildSubTree).filter(Boolean);

		if (items?.length) result["items"] = items;
		if (subLocations?.length) result["sub-location"] = subLocations;

		return result;
	};

	const buildTargets = (rootNode) => {
		if (!rootNode?.selected) return [];

		const targets = [];

		rootNode.locations?.forEach(child => {
			const target = buildSubTree(child);
			if (target) targets.push(target);
		});

		rootNode.items?.forEach(item => {
			if (item.selected) {
				targets.push({
					description: item.desc || '',
					item_id: item.item_id,
					parent_location_id: item.location_id,
					type: 'item'
				});
			}
		});

		return targets;
	};

	useEffect(() => {
		const updatedTargets = buildTargets(nestedData);
		setTargets(updatedTargets);  
	}, [nestedData]);

	
  return (
    <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
      <Grid container spacing={2}>

        {/* Add Checklist Heading */}
        <Grid item xs={12}>
          <Typography variant="h5">
            <Link to="/firehouse/checklist" style={{ color: "black" }}>
              <ArrowBackIosIcon />
            </Link>
            Add Checklist Definition</Typography>
        </Grid>

				 {/* Title */}
        <Grid item xs={12} sm={6} md={6}>
          <label className='my-2'>Title Enter*</label>
          <TextField
            fullWidth
            variant="outlined"
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter Title"
            sx={{
              "& .MuiInputBase-root": {
                height: "48px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center"
              }
            }}
          />
        </Grid>

        {/* Parent Location */}
        <Grid item xs={12} sm={6} md={6}>
          <label className='my-2'>Parent Location*</label>
          <Autocomplete
            options={locationDrop}
            getOptionLabel={(option) => option.label}
            onChange={(event, newValue) => setLocation(newValue?.value || "")}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Location"
                variant="outlined"
                fullWidth
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "48px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }
                }}
              />
            )}
          />
        </Grid>

        {/* Hierarchy Box */}
        <Grid item xs={12} sm={6} md={12} sx={{ marginBottom: '20px' }}>

          {location == 0 &&
            <Box className='hierarchy-box' >
              <img src='/images/empty.png' style={{ height: 200, width: 250 }}>
              </img>
            </Box>
          }

          {location > 0 && nestedData &&
            <Box className='lines' style={{ paddingBottom: '6px' }}>
              <AddChecklistHierarchy
                key={nestedData.id}
                propdata={nestedData}
                loadData={loadData}
                location={location}
                parentSelected={nestedData.selected}
                setNestedData={setNestedData}
              />
            </Box>
          }

        </Grid>

        {/* Add Decription */}

        {/* <Grid item xs={12} sm={6} md={6}>
                    <label className='my-2 mt-0'>Description</label>
                    <TextField
                        disabled={location > 0 ? false : true}
                        fullWidth
                        variant="outlined"
                        size="small"
                        placeholder="Add Description"
                        value={checklistDesc}
                        onChange={(e) => setChecklistDesc(e.target.value)}
                        sx={{
                            "& .MuiInputBase-root": {
                                height: "48px",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center"
                            }
                        }}
                    />
                </Grid> */}

        {/* Item dropdown */}
        {/* <Grid item xs={12} sm={6} md={2.5}>
                    <label className='my-2 mt-0'>Item</label>
                    <Autocomplete
                        disabled={location > 0 ? false : true}
                        options={itemDrop}
                        onChange={(event, newValue) => setChecklistItem(newValue)}
                        value={checklistItem}
                        sx={{
                            "& .MuiInputBase-root": {
                                height: "48px",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center"
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Item"
                            />
                        )}
                    />
                </Grid> */}


        {/* <Grid item xs={12} sm={6} md={2.5}>
                    <label className='my-2 mt-0'>Location</label>
                    <Autocomplete
                        // disabled={location > 0 ? false : true}
                        disabled={checklistItem != null ? true : false || location > 0 ? false : true}
                        options={itemDrop}
                        onChange={(event, newValue) => setChecklistItem(newValue)}
                        value={checklistItem}
                        sx={{
                            "& .MuiInputBase-root": {
                                height: "48px",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center"
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Location"
                            />
                        )}
                    />
                </Grid> */}

        {/* Plus Button */}

        {/* <Grid item xs={12} sm={6} md={1} className='plus-btn'>
                    <button className='add-btn' onClick={addElement} disabled={location > 0 ? false : true}>
                        <Avatar src="/images/Plus-Blue.png" />
                    </button>
                </Grid> */}

        {/* Postion */}
        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Assign by Position*</label>
          <Autocomplete
            options={positionDrop}
            disabled={assignedTo != null ? true : false || location > 0 ? false : true}
            onChange={(event, newValue) => setPosition(newValue)}
            value={position}
            sx={{
              "& .MuiInputBase-root": {
                height: "48px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center"
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Position"
              />
            )}
          />
        </Grid>

        {/* Assigned to */}
        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Assign by Employee*</label>
          <Autocomplete
            options={employeesNew}
            disabled={position != null ? true : false || location > 0 ? false : true}
            value={assignedTo}
            onChange={(event, newValue) => { setAssignedTo(newValue) }}
            sx={{
              "& .MuiInputBase-root": {
                height: "48px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center"
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Employee"
              />
            )}
          />
        </Grid>

        {/* Duration */}
        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Duration*</label>
          <Autocomplete
            disabled={location > 0 ? false : true}
            options={durationOptions}
            getOptionLabel={(option) => option.label}
            value={duration ? durationOptions.find(opt => opt.value === duration) || null : null}
            onChange={(_, newValue) => setDuration(newValue ? newValue.value : "")}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                placeholder="Select Duration"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "48px",
                    fontSize: "14px"
                  }
                }}
              />
            )}
          />
        </Grid>

        {/* Calender*/}
        {(duration == 'monthly' || duration == 'everyotherday') &&
          <Grid item xs={12} sm={6} md={4} className='d-grid'>
            <label className='my-2'>Date*</label>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <ButtonDatePicker
                className='w-100'
                label={moment(date).format('YYYY-MM-DD')}
                value={date}
                onChange={(e) => setDate(e)}
                minDate={new Date()}
              />
            </LocalizationProvider>
          </Grid>
        }

        {/*Select Days drop down */}
        {(duration == 'weekly' || duration == 'biweekly') &&
          <Grid item xs={12} sm={6} md={4}>
            <label className='my-2'>Select Day*</label>
            <Autocomplete
              options={dayOptions}
              getOptionLabel={(option) => option.label}
              value={day ? dayOptions.find(opt => opt.value === day) || null : null}
              onChange={(_, newValue) => setDay(newValue ? newValue.value : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  placeholder="Select Day"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "48px",
                      fontSize: "14px"
                    }
                  }}
                />
              )}
            />
          </Grid>}

        {/* /Time Dropdown */}
        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Time*</label>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
              disabled={location > 0 ? false : true}
              // timeSteps={{ minutes: 1 }}
              value={time}
              onChange={(newValue) => setTime(newValue)}
              className='mt-0'
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: '48px',
                  fontSize: '14px'
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        {/* Ticket Assign to */}
        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Assign Ticket to*</label>
          <Autocomplete
            disabled={location > 0 ? false : true}
            options={employees}
            value={ticketAssignTo}
            onChange={(event, newValue) => { setTicketAssignTo(newValue) }}
            sx={{
              "& .MuiInputBase-root": {
                height: "48px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center"
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Employee"
              />
            )}
          />
        </Grid>

        {/* Ticket Notify to */}
        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Notify Ticket to</label>

					<Multiselect
						displayValue="label"
						options={employeesNew}
						showCheckbox
						showArrow
						customCloseIcon={<><img src='/images/cross.png' /></>}
						placeholder='Select Employees'
						selectedValues={ticketNotifyTo}
						onSelect={(e) => setTicketNotifyTo(e)}
						onRemove={(e) => setTicketNotifyTo(e)}
            disable={location > 0 ? false : true}
					/>
        </Grid>

				{/* Notify Checklist Update to */}
        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Notify Checklist Update to*</label>
          <Autocomplete
            options={employees}
            disabled={location > 0 ? false : true}
            value={checklistUpdateTo}
            onChange={(event, newValue) => { setChecklistUpdateTo(newValue) }}
            sx={{
              "& .MuiInputBase-root": {
                height: "48px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center"
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Employee"
              />
            )}
          />
        </Grid>

        <Grid item container md={12} gap={4} style={{ marginTop: '8px' }}>

          {/* Add Button */}
          <Grid item xs={6} md={1}>
            <ButtonTheme type='submit' variant="filled" color='primary' className='px-5' onClick={() => addChecklist()}>
              Add
            </ButtonTheme>
          </Grid>

          {/* Cancel Button */}
          <Grid item xs={6} md={1}>
            <Link to="/firehouse/checklist">
              <ButtonTheme
                type='submit'
                variant="filled"
                className='px-5 mx-2'
                color='#D0D5DD'
              >
                Cancel
              </ButtonTheme>
            </Link>
          </Grid>
        </Grid>

        {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'normal', marginLeft: '16px', marginTop: '20px', gap: '15px' }}>
                    <ButtonTheme type='submit' variant="filled" color='primary' className='px-5' onClick={() => addChecklist()}>
                        Add
                    </ButtonTheme>
                    <Link to="/firehouse/checklist">
                        <ButtonTheme
                            type='submit'
                            variant="filled"
                            className='px-5 mx-2'
                            color='#D0D5DD'
                        >
                            Cancel
                        </ButtonTheme>
                    </Link>
                </div> */}
      </Grid>
    </Paper >
  );
}

export default AddChecklist;

{/* Checklist Details Heading */ }
{/* <Grid item xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
    <div className='d-flex justify-content-between '>
        <Typography variant="h6">Checklist Detail</Typography>
    </div>
</Grid> */}

{/* Description Box */ }
// {
//     detailsArr.length > 0 && detailsArr.map((a) => (
//         <Grid item xs={12} sm={6} md={6}>
//             <div>
//                 <Grid item>
//                     <TextField
//                         fullWidth
//                         variant="outlined"
//                         size="normal"
//                         height="75px"
//                         disabled
//                         multiline
//                         value={a.desc || 'NO DESCRIPTION'}
//                         InputProps={{
//                             sx: {
//                                 '& fieldset': { borderColor: '#CCCCCC' },
//                                 backgroundColor: '#F5F5F566',
//                                 '& .MuiInputBase-input.Mui-disabled': {
//                                     color: 'black',
//                                     WebkitTextFillColor: a.desc == '' ? '#D0D5DD !important' : 'black !important',
//                                     fontFamily: "Karla",
//                                     fontWeight: "400"
//                                 },
//                             },

//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <img src='/images/Building.png' style={{ width: 30, height: 30 }} />
//                                 </InputAdornment>
//                             ),

//                             endAdornment: (
//                                 <InputAdornment position="end">
//                                     <Grid container direction="column" alignItems="flex-end">

//                                         <Grid item md={12}>
//                                             <button className='add-btn' onClick={() => editElement(a)}>
//                                                 <img src='/images/edit.png' style={{ width: 15, height: 15 }} />
//                                             </button>
//                                             <button className='add-btn' onClick={() => deleteElement(a)}>
//                                                 <img src='/images/cross 1.png' style={{ width: 16, height: 16, marginLeft: 8 }} />
//                                             </button>
//                                         </Grid>

//                                         <Grid item md={12}>
//                                             <Typography variant="body2" className='mt-1'>
//                                                 <span className='font-fam-2'>Item: </span> <span className='item-style'>{a.label}</span>
//                                             </Typography>
//                                         </Grid>

//                                     </Grid>
//                                 </InputAdornment>
//                             )
//                         }}
//                     />
//                 </Grid>
//             </div>
//         </Grid>
//     ))
// }
